import ProductForm from "./forms/ProductForm"




const RegisterProduct = () => {



  return (
    <>
        <ProductForm/>
    </>
  )
}

export default RegisterProduct